module.exports = __webpack_public_path__ + "static/img/3.a7778c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/zlgl/3.jpg
// module id = 2h5v
// module chunks = 0